import React from 'react';
import { Heart, Mail, Phone, MapPin, Instagram, Youtube, Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-amber-400">Made in Heaven</h3>
            <p className="text-gray-400 leading-relaxed">
              Vadodara's premier event management and decoration company. We create unforgettable 
              experiences for weddings, corporate events, and celebrations.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/madeinheavenevents"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors duration-300"
                title="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/made_in_heavan_events?igsh=MXV2OXAwY2JxaDd3dw%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-gradient-to-r hover:from-purple-600 hover:to-pink-600 transition-all duration-300"
                title="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://youtube.com/@madeinheavenevent?si=DIOzLuF2eOyFX5Z3"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors duration-300"
                title="YouTube"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-amber-400 transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-amber-400 transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-amber-400 transition-colors"
                >
                  Our Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-400 hover:text-amber-400 transition-colors"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-400 hover:text-amber-400 transition-colors"
                >
                  Testimonials
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Our Services</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Wedding Planning</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Corporate Events</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Birthday Parties</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Event Decoration</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Catering Services</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="text-amber-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">
                  Vadodara, Gujarat, India
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="text-amber-400 flex-shrink-0 mt-1" size={20} />
                <a href="tel:+919638063350" className="text-gray-400 hover:text-amber-400 transition-colors">
                  +91 96380 63350
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="text-amber-400 flex-shrink-0 mt-1" size={20} />
                <a href="mailto:Singhanant198@gmail.com" className="text-gray-400 hover:text-amber-400 transition-colors">
                  Singhanant198@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Made in Heaven. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm flex items-center gap-2">
              Crafted with <Heart className="text-red-500 fill-red-500" size={16} /> in Vadodara
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
